export default "__VITE_ASSET__645f1517__"